@if (auth.isAuthenticated()) {
<ce-toast-notification />
}
<router-outlet></router-outlet>
